import React, { useState } from 'react';
import  '../sections/Education.css';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import * as data from '../../Lokesh_Profile.json'
import Typography from '@material-ui/core/Typography';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}
const WorkExp = data.WorkExp;
const Edu = data.Edu;
const Achievements = data.Achievements;
const skills = data.skills;
const certificate = data.certificate;
const Profile = data.Profile;
// const WorkExp = [{
//   "name":"Social Survey",
//   "location":"Chennai - India",
//   "from":"Dec 2020",
//   "to":"Present",
//   "designation":"Software Engineer"
// },
// {
//   "name":"DXC Technology",
//   "location":"Chennai - India",
//   "from":"Nov 2019",
//   "to":"Nov 2020",
//   "designation":"Associate Professional Product Developer"
// },
// {
//   "name":"Ingram Micro India SSC Pvt Ltd.",
//   "location":"Chennai - India",
//   "from":"July2018 ",
//   "to":"Nov2019",
//   "designation":"Software Developer"
// },
// ]
// const Edu = [
//   {
//     "degree":"B.Tech",
//     "branch":"Information Technology",
//     "college":"Sathyabama Institute Of Science and Technology",
//     "from":"2014",
//     "to":"2018",
//     "location":"Chennai - India",
//     "cgpa":"8.4"
//   }
// ]
// const Achievements = [{
//   "name":"REMIBAI JEPPIAR SCHOLARSHIP",
//   "org":"Sathyabama Institute of Science and Technology",
//   "desc":"Awarded with a Merit Scholarship for the Academic Year 2017-2018",
//   "year":'Mar 2018'
// },
// {
//   "name":"REMIBAI JEPPIAR SCHOLARSHIP",
//   "org":"Sathyabama Institute of Science and Technology",
//   "desc":"Awarded with a Merit Scholarship for the Academic Year 2016-2017",
//   "year":'Mar 2017'
// }
// ,
// {
//   "name":"REMIBAI JEPPIAR SCHOLARSHIP",
//   "org":"Sathyabama Institute of Science and Technology",
//   "desc":"Awarded with a Merit Scholarship for the Academic Year 2015-2016",
//   "year":'Mar 2016'
// }]
// const skills = [{
//   "name":"React JS",
//   "per": "90"
// },
// {
//   "name":"React Native",
//   "per": "65"
// },
// {
//   "name":"HTML",
//   "per": "85"
// },
// {
//   "name":"Node JS",
//   "per": "65"
// },
// {
//   "name":".NET",
//   "per": "85"
// },
// {
//   "name":"SQL",
//   "per": "75"
// },
// {
//   "name":"Mongo DB",
//   "per": "65"
// },
// ]
// const certificate = [{
//   "name":"Become a React Developer.",
//   "issuer":"LinkedIn Learning",
//   "issuedon":'29-Sept-2020',
//   "URL":"https://drive.google.com/file/d/1T1iRhQoaqEF9Ceu1ggzel8lmEbECusEF/view?usp=sharing"

// },

// {
//   "name":"Building a Website with Node.js and Express.js.",
//   "issuer":"LinkedIn Learning",
//   "issuedon":'11-Sept-2020',
//   "URL":"https://drive.google.com/file/d/1ezjQlvVwLtQuQ--QVV4k8EPQxczhCvpk/view?usp=sharing"
  
// },
// {
//   "name":"React.js: Building an Interface.",
//   "issuer":"LinkedIn Learning",
//   "issuedon":'18-Apr-2020',
//   "URL":"https://drive.google.com/file/d/1FxVUa6BdakaENBPqXmpUdotxNaALg4d3/view?usp=sharing"
  
// },

// {
//   "name":"React.js: Building an Interface.",
//   "issuer":"LinkedIn Learning",
//   "issuedon":'18-Apr-2020',
//   "URL":"https://drive.google.com/file/d/1FxVUa6BdakaENBPqXmpUdotxNaALg4d3/view?usp=sharing"
  
// },
// {
//   "name":"React.js Essential Training.",
//   "issuer":"LinkedIn Learning",
//   "issuedon":'16-Apr-2020',
//   "URL":"https://drive.google.com/file/d/1-BLmcKGrLSUMYHbylM5pYoku7LBIoYf0/view?usp=sharing"
// }
// ,
// {
//   "name":"React: Creating and Hosting a Full-Stack Site.",
//   "issuer":"LinkedIn Learning",
//   "issuedon":'29-Sep-2020',
//   "URL":"https://drive.google.com/file/d/1tCKN_-d1Xx6Q51NU0drN8fBciJd8lwnE/view?usp=sharing"
// },
// {
//   "name":"Node.js Essential Training.",
//   "issuer":"LinkedIn Learning",
//   "issuedon":'15-Apr-2020',
//   "URL":"https://drive.google.com/file/d/1Kq8gJHMBAAcdnokTvzkCv2fVbmjzQdGy/view?usp=sharing"
// },
// {
//   "name":"MongoDB for MEAN Stack Developers.",
//   "issuer":"LinkedIn Learning",
//   "issuedon":'07-Jun-2020',
//   "URL":"https://drive.google.com/file/d/1jUuAkbux05HJwf6HOSXgvlFHZ3OllvRR/view?usp=sharing"
// },
// {
//   "name":"Learning Redux.",
//   "issuer":"LinkedIn Learning",
//   "issuedon":'19-May-2020',
//   "URL":"https://drive.google.com/file/d/1NQ-yjo-ckCz436e-jFow5zJDYNQNCGaB/view?usp=sharing"
// },
// {
//   "name":"Advanced Node.js.",
//   "issuer":"LinkedIn Learning",
//   "issuedon":'22-Jun-2020',
//   "URL":"https://drive.google.com/file/d/1tKfbVJdLdaCPqbFx7xCao8J1OASSf9nz/view?usp=sharing"
// },
// ]
// const Profile = [{
//   headline:"I'm a Software Engineer & Fullstack Web Developer from India. I aim to make a difference through my skills and experience."
// }]
const Education = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );



  return (
    <section
    {...props}
  >
    <div className="container" style={{marginTop:'20vh'}}>
        <div class="row d-flex justify-content-end mt-5">
          	<div class=" col-md-12">
          		<div class="profile fadeInUp  reveal-from-bottom"  data-reveal-delay="200">
	          		<h2 class="mb-4">Profile</h2>
	          		<h4 class="mb-4">{Profile[0].headline}</h4>
	          	<p>Below listed is all my Experience, Education and Certifications:</p>
	        
          		</div>

          		<div class="exp mt-5fadeInUp  reveal-from-bottom"  data-reveal-delay="300">
					     <h2 class="mb-4">	Work Experience</h2>
               {/* <Timeline > */}
              
                 {WorkExp && WorkExp.length > 0 ?
                  
                  WorkExp.map(exp => 

                  // <TimelineItem>
                  //   <TimelineOppositeContent>
                  //     <Typography>{exp.to}</Typography>
                  //   </TimelineOppositeContent>
                  //   <TimelineSeparator>
                  //     <TimelineDot />
                  //     <TimelineConnector />
                      
                  //   </TimelineSeparator>
                  //   <TimelineContent>
                  //     <div>
                  //     <h4>{exp.designation}<span> - {exp.name}</span> </h4>
                  //       <p class="location">{exp.location}</p>
                  //     </div>
                  //   </TimelineContent>
                  // </TimelineItem>

                  <div class="exp-wrap ">
                  <div class="desc">
                    <h4>{exp.designation}<span> {exp.name}</span> </h4>
                    <p class="location">{exp.location}</p>
                  </div>
                  <div class="year" style={{fontSize:'16px',marginTop:'25px'}}>
                    <p>{exp.from} - {exp.to}</p>
                  </div>
                </div>
                  )
                  :
                  <></>
                  }
                  {/* </Timeline> */}

          		<div class="exp mt-5 fadeInUp  reveal-from-bottom"  data-reveal-delay="300">
          			<h2 class="mb-4">Education</h2>
                {Edu && Edu.length > 0 ?
                  Edu.map(item => 
                    <div class="exp-wrap">
                    <div class="desc">
                      <h4 style={{marginTop:0}}>{item.degree} in {item.branch}<br/><span>{item.college}</span> </h4>
                      <p class="location">{item.location}</p>
                      <p class="location">CGPA - {item.cgpa}</p>
                    </div>
                    <div class="year">
                      <p>{item.from} - {item.to}</p>
                    </div>
                  </div>
                    
                    )
                :
                <></>
                }
          		
								
								<div class="exp mt-5 fadeInUp  reveal-from-bottom"  data-reveal-delay="300">
										{/* <h2 class="mb-4">Open Source</h2>
										
										<div class="exp-wrap py-4">
											<div class="desc">
												<h4>Google Code-in 2019<br /><span>Mentor</span> </h4>
												<p class="location">Tensorflow</p>
											</div>
											<div class="year">
												<p>Dec 2019 - Present</p>
											</div>
										</div>

										<div class="exp-wrap py-4">
											<div class="desc">
												<h4>Google Code-in 2018<br /><span>Mentor</span> </h4>
												<p class="location">Public Labs</p>
											</div>
											<div class="year">
												<p>Sep 2018 - Dec 2018</p>
											</div>
										</div>

										<div class="exp-wrap py-4">
											<div class="desc">
												<h4>Google Summer of Code 2019<br /><span>Mentor</span> </h4>
												<p class="location">Public Labs</p>
											</div>
											<div class="year">
												<p>May 2019 - August 2019</p>
											</div>
										</div> */}

										<div style={{marginBottom:0}} class="exp mt-5 fadeInUp  reveal-from-bottom"  data-reveal-delay="300">
												<h2 class="mb-4">Certifications</h2>
                        {certificate && certificate.length > 0 ?
                        certificate.map(item => 
                          <div class="exp-wrap">
													<div >
														<a href={item.URL} target="_blank"></a><h4><a href={item.URL} style={{color:'#2f89fc'}} target="_blank">{item.name}</a><br /><span>{item.issuer}</span> </h4>
													</div>
												</div>
                          )
                        :<></>
                        }
                <div class="exp mt-5 fadeInUp  reveal-from-bottom"  data-reveal-delay="300">
																		<h2 class="mb-4">Achievements</h2>
                                    {Achievements &&  Achievements.length > 0 ?
                                    Achievements.map(item => 
                                      
                                      <div class="exp-wrap ">
                                      <div class="desc">
                                        <h4>{item.name}<br /><span>{item.org}</span> </h4>
                                        <p class="location">{item.desc}.</p>
                                      </div>
                                      <div style={{marginTop:'24px'}} class="year">
                                        <p>{item.year}</p>
                                      </div>
                                    </div>
                                      
                                      )
                                   
                                    :
                                    <></>
                                    }
          		</div>
					</div>
					
          <div class="row mt-5 flex-column  reveal-from-bottom"  data-reveal-delay="300">
          	<div class="col-md-8">
          		<h2 class="mb-4">Skills</h2>
          	</div>
            {skills && skills.length > 0 ?
            skills.map(item => 
              <div class="col-md-6 animate-box">
              <div class="progress-wrap">
                <h4>{item.name}</h4>
                <div class="progress">
                   <div class="progress-bar color-1" role="progressbar" aria-valuenow={item.per}
                    aria-valuemin="0" aria-valuemax="100" style={{width:item.per+"%"}}>
                    <span>{item.per}%</span>
                    </div>
                </div>
              </div>
            </div>
              )
            :
            <></>  
          }
          
          </div> 
        </div>
      </div></div></div></div>
  </div>
  </section>
  );
}

export default Education;